export enum TransactionsTabEnum {
  History = 'history',
  Statements = 'statements',
  CardOrders = 'card-orders',
}
